var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.07 2.35v75.3c0 1.13.6 2.35 1.68 2.35h60.17c.9 0 .92-.16 1.68-.34.17-.75.33-.77.33-1.68V18.82L53.44 0H10.42C8.85 0 8.07.78 8.07 2.35Zm4.8 2.21h36.91l.08 16.06 17.57-.02v54.96H12.87v-71Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.14 7.51H15.99a.98.98 0 0 0-.98.99v1.95c0 .55.44.99.98.99h23.15c.54 0 .98-.44.98-.99V8.5a.98.98 0 0 0-.98-.99Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.14 16H15.99a.98.98 0 0 0-.98 1v1.95c0 .54.44.98.98.98h23.15c.54 0 .98-.44.98-.98v-1.96a.98.98 0 0 0-.98-.98Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.14 25.3H15.99a.98.98 0 0 0-.98.98v1.96c0 .54.44.98.98.98h23.15c.54 0 .98-.44.98-.98v-1.96a.98.98 0 0 0-.98-.98Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 34.42h47.5c.54 0 .98.44.98.98v1.96c0 .54-.44.98-.98.98H16a.99.99 0 0 1-1-.98V35.4a1 1 0 0 1 1-.98Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 42.82h47.5c.54 0 .98.44.98.98v1.96c0 .54-.44.99-.98.99H16a.99.99 0 0 1-1-.99V43.8a1 1 0 0 1 1-.98Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 50.68h47.5c.54 0 .98.44.98.98v1.96c0 .54-.44.99-.98.99H16a.99.99 0 0 1-1-.99v-1.96a1 1 0 0 1 1-.98Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16 59.08h47.5c.54 0 .98.45.98.99v1.96c0 .54-.44.98-.98.98H16a.99.99 0 0 1-1-.98v-1.96a1 1 0 0 1 1-.99Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16 67.49h47.5c.54 0 .98.44.98.98v1.96c0 .54-.44.98-.98.98H16a.99.99 0 0 1-1-.98v-1.96a1 1 0 0 1 1-.98Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReport);
export default ForwardRef;